import { gql } from '@apollo/client';

export const ADD_PROJECT = gql`
  mutation AddProject($input: AddProjectInput) {
    addProject(input: $input) {
      id
      name
      key
      description
      isActive
      createdAt
      createdBy
      updatedAt
      updatedBy
    }
  }
`;

export const ARCHIVE_PROJECT = gql`
  mutation ArchiveProject($input: archiveProjectInput) {
    archiveProject(input: $input)
  }
`;

export const GET_PROJECT = gql`
query Project($input: getProject) {
  project(input: $input) {
    id
    name
    key
    description
    createdBy
    isActive
  }
}
`;

export const GET_PROJECTS = gql`
query Projects {
  getProjectsByUser {
    id
    name
    key
    description
    createdBy
    displayName
    isDisabled
  }
}
`;

export const GET_KEY = gql`
query GetKey($input: ProjectKeyInput!) {
  getProjectKey(input: $input)
}
`;

export const UPDATE_PROJECT = gql`
mutation UpdateProject($input: updateProjectInput) {
  updateProject(input: $input)
}
`;

export const PROJECT_WARNINGS = gql`
query GetProjectWarnings($projectId: Int) {
  getProjectWarnings(project_id: $projectId) {
    id
    project_id
    warning_message
    warning_type
  }
}
`;

export const SHARE_PROJECT = gql`
mutation ShareProject($input: ShareProjectInput) {
  shareProject(input: $input) {
    message
    type
  }
}
`;

export const GET_SHARE_PROJECT = gql`
query GetSharedProjects($input: getSharedProject) {
  getSharedProjects(input: $input) {
    id
    userId
    projectId
    workspaceProfile {
      workspaceId
      logo
      id
      displayName
    }
    user {
      lastName
      firstName
      email
      googleId
      isActive
      lastLoginAt
    }
    project {
      id
      name
      createdBy
    }
    workspaceProfileId
  }
}
`;

export const SHARED_PROJECTS = gql`
query SharedProjects($input: getSharedProject) {
  getSharedProjects(input: $input) {
    id
    userId
    projectId
    user {
      firstName
      lastName
      id
      email
      googleId
    }
    project {
      id
      name
      createdBy
    }
  }
}
`;

export const UNSHARE_PROJECT = gql`
mutation UnshareProject($input: UnshareProjectInput) {
  unshareProject(input: $input) {
    message
    type
  }
}
`;

export const GET_DURATION_AND_START_DATE_OF_PROJECT = gql`
  query Sprint($input: getSprint) {
    sprint(input: $input) {
      start_date
      duration
    }
  }
`;

export const REASSIGN_PROJECT = gql`
mutation ReassignProject($input: reassignProjectInput) {
  reassignProject(input: $input) {
    message
    type
  }
}
`;
